export default __webpack_public_path__ + "static/media/profile-bg.5ae37ea2.jpg";